
import { useEffect, useState } from 'react';
import { getMe } from '../../features/search/service/user-service';
import { User } from '../types/user';

export const useAuthUser = () => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                setLoading(true);
                const userData = await getMe();
                setUser(userData);
                setError(null);
            } catch (err) {
                console.error('❌ Erro ao buscar dados do usuário:', err);
                setError(err instanceof Error ? err.message : 'Erro desconhecido');
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    return { user, loading, error };
};